"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FormTabElement = /** @class */ (function () {
    function FormTabElement(domInfo) {
        this.domInfo = domInfo;
    }
    FormTabElement.prototype.onClone = function (designerContext) {
        if (this.tabIsNotInLayout()) {
            // this.domInfo.addClassToElem('form-designer__tab-component--new');
        }
    };
    FormTabElement.prototype.onDrag = function (designerContext) {
        designerContext.tabDragging = true;
    };
    FormTabElement.prototype.onDrop = function (designerContext) {
        designerContext.tabsComponent.tabJustDropped(designerContext.layoutContent);
        designerContext.isTabBarExists = true;
    };
    FormTabElement.prototype.onHover = function (designerContext) { };
    FormTabElement.prototype.tabIsNotInLayout = function () {
        return this.domInfo.elemIdEquals('tabs_type');
    };
    return FormTabElement;
}());
exports.FormTabElement = FormTabElement;
//# sourceMappingURL=form-tab.element.js.map